export default __webpack_public_path__ + "static/media/landing-blockimg4.6eb6408a.jpg";